import {canv} from '@/canv/global.js';
import {MakeRequest, getTarget, setClick} from '@/canv/utils.js';

export class confirmationWindow {

    constructor() {}


    async open() {

        // если мы закрыли окно, а кто-то отключится и подключился (кейс с highloadMode)
        this.close();

        var confirmationWindowWrapper = document.createElement('div');
        confirmationWindowWrapper.classList.add("confirmationWindowWrapper");
        document.body.prepend(confirmationWindowWrapper);

        confirmationWindowWrapper.innerHTML += this.getMenu();

        this.init();
    }

    init() {
        setClick("confirmationWindowActionsItemAction", this.clickAction.bind(this));
    }


    close() {
        var markWrapper = document.getElementsByClassName("confirmationWindowWrapper")[0];
        if (markWrapper != undefined) {
            markWrapper.outerHTML = "";
        }
    }

    /* Templates */

    getMenu() {
        var template = `
            <div class="confirmationWindow">
                <div class="confirmationWindowAbout">Включен режим высокой нагрузки</div>
                <div class="confirmationWindowDescription">Этот режим включается при большом количестве со-редакторов доски. В нем отключается отображение курсоров со-редакторов.</div>
                <div class="confirmationWindowActions">
                    <div class="confirmationWindowActionsItem confirmationWindowActionsItemAction">Готово</div>
                </div>
            </div>
        `;

        return template;
    }

    /* Proccessors */

    async clickAction() {
        this.close();
    }

}